<template>
  <div class="chartBox" ref="chartBox">
    <!-- style="width: 250px; height: 250px" -->
    <div ref="main" style="width: 300px; height: 300px"></div>
  </div>
</template>
<script>
export default {
  name: "Chart",
  props: {
    option: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      let myChart = this.$echarts.init(this.$refs.main);
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option);
    },
  },
};
</script>
<style scoped lang="less">
.chartBox {
  width: 100%;
  height: 400px;
  margin-top: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>